import { jsx, jsxs } from 'react/jsx-runtime';
import { KubernetesStructuredMetadataTableDrawer } from '../KubernetesDrawer/KubernetesStructuredMetadataTableDrawer.esm.js';
import '../KubernetesDrawer/KubernetesDrawer.esm.js';
import '@backstage/core-components';
import '@material-ui/core/FormControlLabel';
import '@material-ui/core/Switch';
import 'js-yaml';
import 'react';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';

const capitalize = (str) => str.charAt(0).toLocaleUpperCase("en-US") + str.slice(1);
const DefaultCustomResourceDrawer = ({
  customResource,
  customResourceName,
  expanded
}) => {
  const capitalizedName = capitalize(customResourceName);
  return /* @__PURE__ */ jsx(
    KubernetesStructuredMetadataTableDrawer,
    {
      object: customResource,
      expanded,
      kind: capitalizedName,
      renderObject: (cr) => cr,
      children: /* @__PURE__ */ jsxs(
        Grid,
        {
          container: true,
          direction: "column",
          justifyContent: "flex-start",
          alignItems: "flex-start",
          spacing: 0,
          children: [
            /* @__PURE__ */ jsx(Grid, { item: true, children: /* @__PURE__ */ jsx(Typography, { variant: "body1", children: customResource.metadata?.name ?? "unknown object" }) }),
            /* @__PURE__ */ jsx(Grid, { item: true, children: /* @__PURE__ */ jsx(Typography, { color: "textSecondary", variant: "subtitle1", children: capitalizedName }) })
          ]
        }
      )
    }
  );
};

export { DefaultCustomResourceDrawer };
//# sourceMappingURL=DefaultCustomResourceDrawer.esm.js.map
